import {
    AssistanceLevelIds,
    SectionGgResolutionTypeIds,
} from 'src/constants/SectionGgResolutionTypes';
import { CareOutcome, PccTaskFollowUpAnswer } from 'src/store/sageAdminApi';

const displayNameMap: Record<string, string> = {
    PCC: 'PointClickCare',
    AUGUST: 'August Health',
};

/**
 * Maps EHR provider acronyms to their display names
 */
export function getEhrProviderDisplayName(providerName: string): string {
    return displayNameMap[providerName] || providerName || 'your EHR provider';
}

/**
 * Builds PCC task follow up answers from care outcomes
 */
type CareOutcomeWithHelper = CareOutcome & { helperLevel?: string };

// This is a set of care provided ids that have assistance level follow up questions
const PccAssistanceLevelCareProvided = new Set<string>([
    SectionGgResolutionTypeIds.EatingFeeding,
    SectionGgResolutionTypeIds.OralHygiene,
    SectionGgResolutionTypeIds.Toileting,
    SectionGgResolutionTypeIds.UpperBodyDressing,
    SectionGgResolutionTypeIds.LowerBodyDressing,
    SectionGgResolutionTypeIds.Footwear,
    SectionGgResolutionTypeIds.PersonalHygiene,
    SectionGgResolutionTypeIds.Roll,
    SectionGgResolutionTypeIds.SitToLying,
    SectionGgResolutionTypeIds.LayingToSitting,
    SectionGgResolutionTypeIds.SitToStand,
    SectionGgResolutionTypeIds.ChairTransfer,
    SectionGgResolutionTypeIds.ToiletTransfer,
    SectionGgResolutionTypeIds.TubShowerTransfer,
    SectionGgResolutionTypeIds.CarTransfer,
    SectionGgResolutionTypeIds.PickingUpObject,
]);

export function buildPccTaskFollowUpAnswers(outcomes: CareOutcome[]): PccTaskFollowUpAnswer[] {
    const answers: PccTaskFollowUpAnswer[] = [];
    for (const outcome of outcomes) {
        if (!outcome.assistanceLevel || !PccAssistanceLevelCareProvided.has(outcome.careProvided)) {
            continue;
        }

        answers.push({
            question: 'LEVEL_OF_ASSISTANCE',
            answer: outcome.assistanceLevel,
            careProvided: outcome.careProvided,
        });
        const helperLevel = (outcome as CareOutcomeWithHelper).helperLevel;

        if (outcome.assistanceLevel === AssistanceLevelIds.Dependent && helperLevel) {
            answers.push({
                question: 'HELPER_LEVEL',
                answer: helperLevel,
                careProvided: outcome.careProvided,
            });
        }
    }
    return answers;
}
